import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";

import { goToScene } from "../main";

import { playerState } from "../state/stateManager";
import FarmerJackson from "../actors/characters/farmerJackson";

export default class JacksonsHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(20 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.jackson = new FarmerJackson(
      { x: 14 * 16, y: 6 * 16 },
      "jacksonsHouse"
    );
  }
  onInitialize(engine) {
    Resources.JacksonsHouse.addToScene(this);
    console.log("jacksonsHouse: adding player: ", this.player);
    this.player.lastDir = "up";

    this.add(this.player);

    this.camera.zoom = 1;

    this.door = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 18 * 16 + 8),
      width: 64,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("crossroads", { x: 6 * 16, y: 13 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "jackson") {
        this.jackson.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    if (content.npcLocations.jackson.location == 0) {
      this.add(this.jackson);
    }
  }
  onPostUpdate() {}
}
